/**
 * Auth Telemetry — fire-and-forget breadcrumb client
 * ====================================================
 * Backend `/api/public/auth-telemetry` endpoint'ine state transitions +
 * critical errors gönderir. Sentry değil — Render log search-friendly.
 *
 * Tek SSoT: useAuthBootstrap + AuthGate her ikisi de buradan emit eder.
 * (Code duplication önlendi, helper drift kaynağı kapatıldı.)
 */

// Session-stable telemetry id (anonim, sayfa refresh sonrası farklı)
let SESSION_ID: string | null = null;

export function getSessionId(): string {
  if (typeof window === 'undefined') return 'ssr';
  if (!SESSION_ID) {
    SESSION_ID = `s-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 8)}`;
  }
  return SESSION_ID;
}

/**
 * Fire-and-forget telemetry. sendBeacon preferred (sayfa unload sırasında bile
 * çalışır). Fallback: fetch keepalive. Sessizce fail eder — UI'yı bloke etmez.
 *
 * Path field'ı pathname-only gönderilir (PII koruma — backend de defansif sanitize).
 */
export function emitAuthTelemetry(event: string, payload?: Record<string, unknown>): void {
  if (typeof window === 'undefined') return;

  const apiBase = process.env.NEXT_PUBLIC_API_URL || '';
  const url = `${apiBase}/api/public/auth-telemetry`;

  // path pathname-only (query string PII içerebilir)
  const path = window.location?.pathname;

  const body = JSON.stringify({
    event,
    sessionId: getSessionId(),
    path,
    ...(payload || {})
  });

  try {
    if (navigator?.sendBeacon) {
      const blob = new Blob([body], { type: 'application/json' });
      navigator.sendBeacon(url, blob);
    } else {
      fetch(url, {
        method: 'POST',
        body,
        headers: { 'Content-Type': 'application/json' },
        keepalive: true
      }).catch(() => {});
    }
  } catch {
    // sessiz — telemetry hatası UI'yı bozmasın
  }
}

/** Backend whitelist ile senkron — diğer event'ler 204 ile drop edilir */
export const AUTH_TELEMETRY_EVENTS = {
  STATE_TRANSITION_TERMINAL: 'state.transition.terminal',
  FETCH_PROFILE_ERROR: 'fetchProfile.error',
  FETCH_PROFILE_RETRY_CANCELLED: 'fetchProfile.retry.cancelled',
  AUTHGATE_REDIRECT: 'authgate.redirect'
} as const;
